import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

// Nombres de todos los vendedores activos (admin) + los que aparezcan en los registros.
export function useVendedoresActivos(isAdmin, rows = [], getNombre) {
  const [activos, setActivos] = useState([]);
  useEffect(() => {
    if (isAdmin) api.get("/avisos/vendedores").then(({ data }) => setActivos((data || []).filter((v) => v.estatus === "activo").map((v) => v.full_name))).catch(() => {});
  }, [isAdmin]);
  return useMemo(() => {
    const s = new Set(activos);
    rows.forEach((r) => { const n = getNombre(r); if (n) s.add(n); });
    return Array.from(s).sort((a, b) => a.localeCompare(b));
  }, [activos, rows, getNombre]);
}
